// Constantes centrais de marca — App Saúde
export const APP_NAME = 'App Saúde';
export const BRAND_WORDMARK = 'Saúde';
export const BRAND_TAGLINE = 'Vai até você';
export const BRAND_LOGO_LIGHT = '/images/logo.png';
export const BRAND_LOGO_DARK = '/images/dark-logo.png';
